import { createSchema, Yup } from '@src/corelib/validation';


/**
 * Location form schema (T11). `name` is the only required field — matching the
 * onboarding AddLocation flow's inline "Name this location" message. The address
 * fields are optional strings; enforcement of any server-side rules is left to
 * the API, whose 400 field errors still map back onto the inputs via the Form's
 * `showServerErrors`. All fields stay `Yup.string()` so the wire payload remains
 * the full {name, address, city, region, postal_code} object of strings.
 */
const locationSchema = createSchema({
  name: Yup.string().required('Name this location'),
  address: Yup.string(),
  city: Yup.string(),
  region: Yup.string(),
  postal_code: Yup.string(),
});


/** Map a location record onto the form's string-valued shape. */
function locationDefaults(location) {
  return {
    name: location?.name || '',
    address: location?.address || '',
    city: location?.city || '',
    region: location?.region || '',
    postal_code: location?.postal_code || '',
  };
}


export {
  locationDefaults,
  locationSchema,
};
